// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

export const ErrorMessage = styled.div`
  color: var(--mb-color-error);
  margin-top: 0.5rem;
`;
